import { render, staticRenderFns } from "./postGoogle.vue?vue&type=template&id=fa537fbc"
import script from "./postGoogle.vue?vue&type=script&lang=js"
export * from "./postGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa537fbc')) {
      api.createRecord('fa537fbc', component.options)
    } else {
      api.reload('fa537fbc', component.options)
    }
    module.hot.accept("./postGoogle.vue?vue&type=template&id=fa537fbc", function () {
      api.rerender('fa537fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postGoogle.vue"
export default component.exports